import { ErrorAlert } from '@/components/_ui/ErrorAlert'
import { FixedReportIssueButton } from '@/components/FixedReportIssueButton'
import { ProductsBanner } from '@/components/Products/ProductsBanner'
import { ProductsGrid } from '@/components/Products/ProductsGrid'
import { ProductsSortBy } from '@/components/Products/ProductsSortBy'
import type { CosmicCategoryResponseType } from '@/lib/cms/cosmic/types/CosmicCategoryType'
import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { CMSError } from '@/lib/cms/types/CMSError'
import type { CosmicBannerDataType } from '@/lib/cms/cosmic/types/CosmicProductsBannerType'
import { Error404 } from '@/components/_ui/Error404'
import LandingPageLayout from '../LandingPageLayout'

type Props = {
  productsBannerImageData: CosmicBannerDataType | { error: CMSError } | null
  productCategoryData: CosmicCategoryResponseType | { error: CMSError } | null
  products: CosmicProductType[] | { error: CMSError } | null
}

export const GridPageLayout = ({
  productsBannerImageData,
  productCategoryData,
  products,
}: Props) => {
  const handleRenderProductsInCategory = () => {
    if (!products || !productCategoryData) {
      return (
        <div className="w-full">
          <ErrorAlert
            error={{
              error: {
                message: 'Unknown error',
                code: 404,
              },
            }}
          />
        </div>
      )
    }

    if ('error' in products) {
      return (
        <div className="mt-5 w-full">
          <Error404 />
        </div>
      )
    }

    if ('error' in productCategoryData) {
      return (
        <div className="w-full">
          <ErrorAlert error={productCategoryData} />
        </div>
      )
    }

    return (
      <>
        <div className="mt-10 flex w-full flex-col items-center justify-between gap-4 px-5 md:flex-row">
          <h1 className="text-center text-3xl font-bold">
            {productCategoryData.name}
          </h1>

          <ProductsSortBy />
        </div>
        {productCategoryData.description && (
          <div
            dangerouslySetInnerHTML={{
              __html: productCategoryData.description,
            }}
            className="mt-10 flex w-full flex-col items-center justify-between gap-4 px-5 md:flex-row"
          />
        )}

        <ProductsGrid products={products} />
      </>
    )
  }

  return (
    <LandingPageLayout products={products}>
      <FixedReportIssueButton />

      <div className="bg-[#FAFAFA]">
        <header className="flex justify-center">
          <ProductsBanner productsBannerImageData={productsBannerImageData} />
        </header>

        <main className="m-auto flex min-h-screen max-w-[1400px] flex-col items-center justify-start overflow-x-hidden">
          {handleRenderProductsInCategory()}
        </main>
      </div>
    </LandingPageLayout>
  )
}
